import { useState, useEffect, useContext } from 'react';
import { StateContext } from '../../../../Controllers/context/state';
import { PercentileMoves, InfoScore } from '../constants';

export const useChartFilters = (historicalData, chartType, symbol) => {
    const { setShowChartInfoWindow } = useContext(StateContext);
    const [selectedInfoScore, setSelectedInfoScore] = useState(InfoScore.values[5].value);
    const [selectedPercentile, setSelectedPercentile] = useState(PercentileMoves.values[5].value);
    const [filteredHistoricalData, setFilteredHistoricalData] = useState([]);
    const [eventTypes, setEventTypes] = useState([]);
    const [selectedEventType, setSelectedEventType] = useState('All');
    const [isFiltersOpen, setIsFiltersOpen] = useState(false);
    const [isEventTypesOpen, setIsEventTypesOpen] = useState(false);
    const [eventTypeSearch, setEventTypeSearch] = useState('');

    useEffect(() => {
        if (historicalData.length > 0) {
            const { lower, upper } = selectedPercentile;

            const baseFilteredData = historicalData.filter(item => {
                if (item.stats && item.stats?.tags?.length > 0) {
                    const percentileCondition = (item.stats.date_return_oc_percentile <= lower ||
                        item.stats.date_return_oc_percentile >= upper);
                    const infoScore = item.stats.information_score;

                    return percentileCondition &&
                        (infoScore === null || infoScore === undefined || infoScore >= selectedInfoScore);
                }
            });

            const allTags = baseFilteredData
                .filter(item => item.stats && item.stats.tags && item.stats.tags.length > 0)
                .flatMap(item => item.stats.tags);

            const tagCounts = allTags.reduce((acc, tag) => {
                acc[tag] = (acc[tag] || 0) + 1;
                return acc;
            }, {});

            const eventTypesWithCounts = Object.entries(tagCounts)
                .map(([tag, count]) => ({ name: tag, count }))
                .sort((a, b) => a.name.localeCompare(b.name));

            setEventTypes(eventTypesWithCounts);
        } else {
            setEventTypes([]);
        }
    }, [selectedPercentile, historicalData, selectedInfoScore]);

    useEffect(() => {
        if (historicalData.length > 0) {
            const { lower, upper } = selectedPercentile;

            let filteredData = historicalData.filter(item => {
                if (item.stats && item.stats?.tags?.length > 0) {
                    const percentileCondition = (item.stats.date_return_oc_percentile <= lower ||
                        item.stats.date_return_oc_percentile >= upper);
                    const infoScore = item.stats.information_score;

                    return percentileCondition &&
                        (infoScore === null || infoScore === undefined || infoScore >= selectedInfoScore);
                }
            });

            // Apply event type filter
            if (selectedEventType !== 'All') {
                filteredData = filteredData.filter(item =>
                    item.stats?.tags?.includes(selectedEventType)
                );
            }

            setFilteredHistoricalData(filteredData);
        } else {
            setFilteredHistoricalData([]);
        }
    }, [selectedPercentile, historicalData, selectedInfoScore, selectedEventType]);

    useEffect(() => {
        setIsFiltersOpen(false);
        setSelectedEventType('All');
        setFilteredHistoricalData([]);
        setShowChartInfoWindow(false);
    }, [chartType, setShowChartInfoWindow]);

    useEffect(() => {
        setIsFiltersOpen(false);
        setSelectedEventType('All');
        setShowChartInfoWindow(false);
    }, [symbol, setShowChartInfoWindow]);

    useEffect(() => {
        setShowChartInfoWindow(false);
    }, [selectedPercentile, selectedInfoScore, selectedEventType, setShowChartInfoWindow]);

    useEffect(() => {
        if (!isFiltersOpen) {
            setIsEventTypesOpen(false);
            setEventTypeSearch('');
        }
    }, [isFiltersOpen]);

    const handleChangePercentile = (e) => {
        const selectedValue = JSON.parse(e.target.value);
        setSelectedPercentile(selectedValue);
    };

    const handleChangeInfoScore = (e) => {
        setSelectedInfoScore(e.target.value);
    };

    return {
        selectedInfoScore,
        selectedPercentile,
        filteredHistoricalData,
        eventTypes,
        selectedEventType,
        isFiltersOpen,
        isEventTypesOpen,
        eventTypeSearch,
        setSelectedEventType,
        setIsFiltersOpen,
        setIsEventTypesOpen,
        setEventTypeSearch,
        handleChangePercentile,
        handleChangeInfoScore
    };
};


